import { useRouteAccess } from '@omnea-app/fe-authz/useRouteAccess'
import {
  useGetDynamicAssigneesWithArchivedScopeCount,
  useGetMissingDynamicAssigneesCount,
} from '@omnea-app/fe-budget-approvals/useBudgetApprovals'
import { useListWorkflows } from '@omnea-app/fe-reporting/useListWorkflows'
import { WorkflowStateEnum } from '@omnea-app/packages/universal/workflow/workflowEnums'

export type OrgConfigIssueKey = 'broken-workflows' | 'missing-assignees' | 'archived-core-data'

export type OrgConfigIssue = {
  key: OrgConfigIssueKey
  count: number
  href: string
}

export const useOrgConfigIssuesBannerInfo = () => {
  const routeAccess = useRouteAccess()
  const workflowsAnswer = routeAccess.get('settingsWorkflows')
  const dynamicAssigneesAnswer = routeAccess.get('settingsDynamicAssignees')

  const canFixWorkflows = workflowsAnswer === 'allowed'
  const canFixDynamicAssignees = dynamicAssigneesAnswer === 'allowed'
  const isAccessLoading = workflowsAnswer === 'pending' || dynamicAssigneesAnswer === 'pending'

  const { data: workflowsData, isLoading: isWorkflowsLoading } = useListWorkflows({
    skip: !canFixWorkflows,
    state: [WorkflowStateEnum.UNDER_MAINTENANCE],
  })
  const { data: missingAssigneesData, isLoading: isMissingAssigneesLoading } = useGetMissingDynamicAssigneesCount({
    skip: !canFixDynamicAssignees,
  })
  const { data: archivedScopeData, isLoading: isArchivedScopeLoading } = useGetDynamicAssigneesWithArchivedScopeCount({
    skip: !canFixDynamicAssignees,
  })

  const isLoading = isAccessLoading || isWorkflowsLoading || isMissingAssigneesLoading || isArchivedScopeLoading

  const issues: OrgConfigIssue[] = [
    {
      key: 'broken-workflows',
      count: workflowsData?.workflows.length ?? 0,
      href: '/settings/workflows',
    },
    {
      key: 'missing-assignees',
      count: missingAssigneesData?.count ?? 0,
      href: '/settings/dynamic-assignees',
    },
    {
      key: 'archived-core-data',
      count: archivedScopeData?.count ?? 0,
      href: '/settings/dynamic-assignees',
    },
  ]

  const activeIssues = issues.filter((issue) => issue.count > 0)

  return {
    shouldShowBanner: activeIssues.length > 0,
    issues: activeIssues,
    totalCount: activeIssues.reduce((total, issue) => total + issue.count, 0),
    isLoading,
  }
}
